module.exports = __webpack_public_path__ + "img/vision.2a5bafd2.svg";